<section class="page">
  <header class="page-header">
    <h2>Cibles biologiques</h2>
    <p class="subtitle">Créer, modifier et voir/supprimer les cibles utilisées dans les analyses.</p>
  </header>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (showCreateSection) {
    <div class="forms-grid">
      <form class="panel" (ngSubmit)="createCible()">
        <h3>Créer une cible biologique</h3>

        <label for="nouveau-nom">Nom</label>
        <input id="nouveau-nom" name="nouveauNom" [(ngModel)]="nouveauNom" maxlength="255" required />

        <button type="submit" [disabled]="loading">Créer</button>
      </form>
    </div>
  }

  @if (showEditSection) {
    <div class="forms-grid">
      <form class="panel" (ngSubmit)="updateCible()">
        <h3>Éditer une cible biologique</h3>

        <label for="select-cible">Cible biologique</label>
        <select id="select-cible" name="selectedId" [(ngModel)]="selectedId" (ngModelChange)="onSelectChange()">
          <option value="">-- sélectionner --</option>
          @for (cible of cibles; track cible.id) {
            <option [value]="cible.id">{{ cible.nom }}</option>
          }
        </select>

        <label for="nom-edition">Nouveau nom</label>
        <input id="nom-edition" name="nomEdition" [(ngModel)]="nomEdition" maxlength="255" required />

        <button type="submit" [disabled]="loading">Enregistrer</button>
      </form>
    </div>
  }

  @if (showListSection) {
    <section class="panel">
      <h3>Liste des cibles biologiques</h3>
      @if (loadingList) {
        <p>Chargement des cibles biologiques...</p>
      } @else if (cibles.length === 0) {
        <p>Aucune cible biologique disponible.</p>
      } @else {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nom</th>
                @if (showDeleteActionsInTable) {
                  <th>Actions</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (cible of cibles; track cible.id) {
                <tr>
                  <td>{{ cible.id }}</td>
                  <td>{{ cible.nom }}</td>
                  @if (showDeleteActionsInTable) {
                    <td class="actions-cell">
                      <button
                        type="button"
                        class="danger"
                        [disabled]="loading || deletingCibleId === cible.id"
                        (click)="deleteCibleRow(cible)"
                      >
                        {{ deletingCibleId === cible.id ? 'Suppression...' : 'Supprimer' }}
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
  }
</section>
